import Button from "@/components/Button/Button.component";
import { Grid, GridItem } from "@/components/Grid/Grid.component";
import Icon from "@/components/Icon/Icon.component";
import { ICON_TYPE } from "@/components/Icon/Icon.model";
import Image from "@/components/Image/Image.component";
import { Typography } from "@/components/Typography/Typography.component";
import NextLink from "next/link";
import { BUTTON_SUBTYPE_CLASS } from "../Button/Button.model";
import { FooterPropsModel } from "./Footer.model";

const Footer = (props: FooterPropsModel) => {
  const {
    buttonText,
    setShowContact,
    brandingText,
    acknowledgement,
    socialLinksCollection,
  } = props;

  return (
    <div className="footer bg-core-black relative h-full overflow-hidden">
      <div className="px-lg py-lg sm:px-sm w-full">
        <Grid hasPadding={false}>
          <GridItem
            span={{ mobile: "full", desktop: 6 }}
            className="grid gap-y-6"
          >
            <Typography.LLABEL2 color="core-white">
              {brandingText}
            </Typography.LLABEL2>
            {buttonText && (
              <div className="md:bottom-lg md:right-lg lg:bottom-lg lg:right-lg relative col-span-4 mb-0 md:absolute md:z-10 md:m-0 lg:z-10 lg:m-0">
                <Button
                  className="mr-1"
                  primary
                  type={BUTTON_SUBTYPE_CLASS.PRIMARY_WHITE}
                  content={{ text: buttonText }}
                  onClick={() => setShowContact(true)}
                />
              </div>
            )}
            <div className="flex flex-wrap gap-4">
              {socialLinksCollection?.map((item, index) =>
                item.url ? (
                  <NextLink
                    key={index}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon
                      type={item.text.toLowerCase() as ICON_TYPE}
                      size={48}
                    />
                  </NextLink>
                ) : null,
              )}
            </div>
          </GridItem>
          <GridItem span={{ mobile: "full", desktop: 6 }}>
            <Typography.BODY2
              color="core-white"
              className="pt-xxxl lg:ml-auto lg:max-w-[350px] lg:pt-0"
            >
              {acknowledgement}
            </Typography.BODY2>
          </GridItem>
        </Grid>
      </div>

      <div className="absolute bottom-0 w-auto">
        <Image
          className="mr-auto"
          alt="ClemengerBBDO logo"
          width={888}
          height={141}
          src="/static/img/Clemenger_BBDO_Brandmark.svg"
        />
      </div>
    </div>
  );
};

export default Footer;
